import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import Settings from '../../../../services/settings.service';
import { LinkSectionButton } from '../../Section';
import Translation from '../../../../services/translation.service';
import { Link } from 'react-router-dom';
import { urlFormatter } from '../../../../util';
const TEMPORARY_URL_PREFIX = `${Settings.REACT_APP_API_BASE_URL}images`;

const SUPPORT_SLUG = 'support';
const SupportMenu = ({
  sections = [],
  lang = 'ar',
  toggleNavMain,
  toggleNav,
  resetNavList,
  routes
}) => {
  const supportItems = useMemo(() => {
    if (!sections) return [];
    return sections?.find(({ slug }) => slug === SUPPORT_SLUG)?.buttons;
  }, [sections, lang]);
  return (
    <li className="nav-list-itm border-bottom">
      <div className="nav-list-lnk pointer" onClick={toggleNavMain}>
        {Translation.key('header_menu_support')}
      </div>
      <div className="sub-nav-wrapper">
        <div className="sub-nav flex-between">
          <div className="back mobile-tablet-only" onClick={resetNavList}>
            <svg
              width="10"
              height="18"
              viewBox="0 0 10 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 17L1.00016 9.00048L9 1.00048"
                stroke="#7C8095"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>{Translation.key('header_menu_support')}</span>
          </div>
          <div className='nav-section flex-column support-desktop'>
            <div className='flex- w-100 support-center-link'>
              <Link className="sub-nav-title" onClick={toggleNav} to={urlFormatter(routes?.['informative-support']?.route)}>
                {Translation.key('support_center_with_arrow')}
              </Link>
            </div>

            <div className="first-links-row align-center menu" >
              {supportItems?.slice(0, 3)?.map(({ url, text, icon, state }, index) => (
                <LinkSectionButton
                  toggleNav={toggleNav}
                  key={text + url}
                  isMainLink={true}
                  imgSrc={TEMPORARY_URL_PREFIX + icon}
                  text={text}
                  url={url}
                  state={state}
                />
              ))}
            </div>
          </div>
          <div className="nav-section second-links-row menu">
            {supportItems?.slice(3)?.map(({ url, text, icon, state }, index) => (
              <LinkSectionButton
                key={text + url}
                toggleNav={toggleNav}
                imgSrc={TEMPORARY_URL_PREFIX + icon}
                text={text}
                url={url}
                state={state}
              />
            ))}
          </div>
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = (state) => ({
  sections: state.homePage.sections,
  routes: state.layout.routes,
});
export default connect(mapStateToProps)(SupportMenu);
